import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Tag/Tag.js",
    _this = this;

import React from 'react';
import { StyledTag } from './style';
var defaultProps = {
  size: 'short',
  rounded: true,
  customStyle: {
    width: 'content-fit',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px'
  }
};
export var Tag = function Tag(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var customStyle = Object.assign({}, defaultProps.customStyle, props.customStyle);
  return /*#__PURE__*/React.createElement(StyledTag, _extends({}, props, {
    customStyle: customStyle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }), children);
};
Tag.defaultProps = defaultProps;
export default Tag;